import { PREVENT_DOUBLE_TAP_DELAY } from '../../constants/time';

let preLastTouchStartAt = 0;
let lastTouchStartAt = 0;

const onTouchStart = () => {
    preLastTouchStartAt = lastTouchStartAt;
    lastTouchStartAt = +new Date();
};

export const onTouchEnd = event => {
    const touchEndAt = +new Date();
    const { target } = event;
    const isZoomed = document.documentElement.clientWidth / window.innerWidth !== 1;
    const isLessThanDelay = touchEndAt - preLastTouchStartAt < PREVENT_DOUBLE_TAP_DELAY;
    // do not prevent double tap to zoom if content
    // is already zoomed (allows to zoom out)
    if (isZoomed || !isLessThanDelay) {
        return;
    }
    if (event.cancelable) {
        event.preventDefault();
    }
    if (target && target.click) {
        target.click();
    }
};

export const initPreventDoubleTapZoom = () => {
    document.addEventListener('touchstart', onTouchStart, { passive: false });
    document.addEventListener('touchend', onTouchEnd, { passive: false });
};

export const destroyPreventDoubleTapZoom = () => {
    document.removeEventListener('touchstart', onTouchStart);
    document.removeEventListener('touchend', onTouchEnd);
};
